import {
  Paper,
  TypographyElement,
  Skeleton
} from 'UI'
import { createUseStyles } from 'react-jss'
import style from './style'
import Text from './text.json'
import Category from 'components/Catalog/Category'
import { CatalogPath } from 'navigation/Routes'

const useStyle = createUseStyles(style)

const numberOfCategoriesToShow = 2

export default ({ Categories = [], handleCategoryClick, margin, loading }) => {
  const { paperClass, categoryNameWrapper } = useStyle({ margin })
  const categoriesToShow = loading ? [...Array(numberOfCategoriesToShow).fill({ loading })] : Categories
  return (
    Categories && Categories.length
      ? (
        <Paper className={paperClass}>
          {
            loading
              ? <Skeleton lines={1} width='60%' height={29} gap={12} margin='0 0 16px 0' />
              : (
                <TypographyElement
                  variant='heading5'
                  spacing='0 0 16px 0'
                  Component='h3'
                >
                  {Text.title}
                </TypographyElement>
                )
          }
          <div className={categoryNameWrapper}>
            {
              categoriesToShow.map((category, key) => {
                const slug = category.loading ? '' : category.CategorySlug ?? category.Name.trim()
                return category.loading
                  ? <Category loading key={`category-course-${key}-${loading}`} />
                  : category.Name.length
                    ? <Category
                        loading={loading}
                        {...category}
                        handleClick={() => {
                          handleCategoryClick(`${CatalogPath}/${slug}`)
                        }}
                        path={`${CatalogPath}/${slug}`}
                        padding='15px'
                      />
                    : null
              }
              )
            }
          </div>
        </Paper>
        )
      : null
  )
}
